import type { Pet } from './pet'

export enum Status {
  OWNER_NOTIFIED = 'owner-notified',
  EMERGENCY_CONTACTS_NOTIFIED = 'emergency-contacts-notified',
  GET_CONTACT_INFORMATION = 'get-contact-information',
  PET_IS_SAFE = 'pet-is-safe',
}

export type FoundPet = {
  willNotifyEmergencyContactsAt: string
  name: string
  email: string
  phone: string
  alternateName?: string
  alternatePhone?: string
  alternateEmail?: string
  pickupInstructions: string
  pet: Pet
  token: string
  status: Status
}
